import { GameDetails } from '../page/GameDetails/GameDetails'

export default GameDetails
